import { EventGroupTicketGroupItem, TicketGroup } from 'src/WebApiController';

import { EventGroupTicketGroupDraft } from './EventGroup.types';

/**
 * Converts ticket group drafts into API-ready EventGroupTicketGroupItem[].
 * Extracted from useEventGroupCreation.ts.
 */
export function buildTicketGroupItems(
  ticketGroups: EventGroupTicketGroupDraft[],
  divisor: number,
  totalCost: number | null
): EventGroupTicketGroupItem[] {
  if (ticketGroups.length === 0 || divisor < 1 || totalCost == null) return [];

  return ticketGroups
    .filter((tg) => tg.quantity > 0)
    .map((tg) => {
      const unitCost = Math.floor((tg.unitCost * 100) / divisor) / 100;
      return {
        section: tg.section,
        row: tg.row || null,
        quantity: tg.quantity,
        unitCost,
        seatFrom: tg.seatFrom || null,
        seatTo: tg.seatTo || null,
        deliveryType: tg.deliveryType,
        currencyCode: tg.currencyCode,
      };
    });
}

/**
 * Builds EventGroupTicketGroupItem[] by copying from existing placeholder
 * event's ticket groups, recalculating unitCost as the average cost per ticket.
 */
export function buildTicketGroupItemsFromExisting(
  existingTicketGroups: TicketGroup[],
  totalGroupCost: number,
  totalTicketCount: number
): EventGroupTicketGroupItem[] {
  if (existingTicketGroups.length === 0 || totalTicketCount <= 0) return [];

  const unitCost = Math.floor((totalGroupCost / totalTicketCount) * 100) / 100;

  return existingTicketGroups.map((tg) => ({
    section: tg.seating?.section ?? '',
    row: tg.seating?.row ?? null,
    quantity: tg.ticketCnt ?? 0,
    unitCost,
    seatFrom: tg.seating?.seatFr ?? null,
    seatTo: tg.seating?.seatTo ?? null,
    deliveryType: tg.delivType,
    currencyCode: tg.currency ?? '',
  }));
}
